import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import DiseaseSection from '~/types/api/disease/DiseaseSection'
import DiseaseSectionIconItem from '~/components/block/DiseaseSectionIconItem'
import { Slider, SlideOptions } from '~/types/Slider'

@Component
export default class DiseaseSectionIconList extends Vue {
  @Prop({ required: true, type: Array })
  readonly items!: DiseaseSection[]

  @Ref()
  readonly slider!: Slider

  options: SlideOptions = {
    slidesToShow: 3,
    infinite: false,
    navButtons: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  }

  get code (): string {
    return JSON.stringify(this.items)
  }

  renderSliderItem (item: DiseaseSection) {
    return (
      <div key={item.id} class="disease-section-icon-list__item-wrapper">
        <div class="disease-section-icon-list__item">
          <DiseaseSectionIconItem {...{
            props: {
              section: item
            }
          }} />
        </div>
      </div>
    )
  }

  render () {
    return (
      <div class="disease-section-icon-list">
        <div class="disease-section-icon-list__row">
          {this.items.map(e => (
            <div key={e.id} class="disease-section-icon-list__col">
              <DiseaseSectionIconItem {...{
                props: {
                  section: e
                }
              }} />
            </div>
          ))}
        </div>
        <div class="disease-section-icon-list__slider">
          <div class="disease-section-icon-list__track">
            <agile key={this.code} ref="slider" options={this.options}>
              {this.items.map(e => this.renderSliderItem(e))}
            </agile>
          </div>
        </div>
      </div>
    )
  }
}
